import clsx from 'clsx';
import { Filters } from 'components/pages/RewardOptions/RewardOptions';
import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { parseRange } from 'utils/formHelper';
import RedemptionOptionItem from './RedemptionOptionItem';
import classes from './RedemptionOptions.module.scss';
import { RedemptionOptions_redemptionOptionsRef$key } from './__generated__/RedemptionOptions_redemptionOptionsRef.graphql';

export interface Props {
  filters: Partial<Filters>;
  redemptionOptionsRef: RedemptionOptions_redemptionOptionsRef$key;
  children?: React.ReactNode;
}

const query = graphql`
  fragment RedemptionOptions_redemptionOptionsRef on RedemptionOptionConnection {
    edges {
      node {
        id
        name
        amountDenominations {
          panelistCost {
            subUnitAmount
          }
        }
        ...useRedemptionOptionItemQuery_optionRef
      }
    }
  }
`;

export default function RedemptionOptions({ filters, redemptionOptionsRef, children }: Props) {
  const redemptionOptions = useFragment<RedemptionOptions_redemptionOptionsRef$key>(
    query,
    redemptionOptionsRef,
  );

  return (
    <div className={clsx(classes.root)}>
      <ul className={clsx(classes.list)}>
        {redemptionOptions.edges
          .filter((item) => {
            if (!filters.search) {
              return true;
            }
            return item.node.name.toLowerCase().includes(filters.search.toLowerCase());
          })
          .filter((item) => {
            if (!filters.points?.length) {
              return true;
            }

            if (!item.node.amountDenominations?.length) {
              return true;
            }

            return (
              filters.points.filter((range) => {
                const [min, max] = parseRange(range);
                return Boolean(
                  item.node.amountDenominations?.find(
                    (denomination) =>
                      denomination.panelistCost.subUnitAmount >= min &&
                      denomination.panelistCost.subUnitAmount <= max,
                  ),
                );
              }).length > 0
            );
          })
          .map(({ node }) => (
            <RedemptionOptionItem
              redemptionType={filters.type || 'GIFT_CARD'}
              key={node.id}
              optionRef={node}
            />
          ))}
        {children}
      </ul>
    </div>
  );
}
